module.exports = __webpack_public_path__ + "static/media/c6a7acbe.jpg";